import { render, staticRenderFns } from "./TableCartBase.vue?vue&type=template&id=63f3ae52&scoped=true"
import script from "./TableCartBase.vue?vue&type=script&lang=js"
export * from "./TableCartBase.vue?vue&type=script&lang=js"
import style0 from "./TableCartBase.vue?vue&type=style&index=0&id=63f3ae52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f3ae52",
  null
  
)

export default component.exports